import { render, staticRenderFns } from "./questionnaireInvestigation.vue?vue&type=template&id=422d40e7&scoped=true&"
import script from "./questionnaireInvestigation.vue?vue&type=script&lang=js&"
export * from "./questionnaireInvestigation.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireInvestigation.vue?vue&type=style&index=0&id=422d40e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d40e7",
  null
  
)

export default component.exports